import { GoogleRecaptchaSettings } from "@/modules/core/types";
import { defineStore } from "pinia";

export const useBcfCommonDataStore = defineStore('bcf-common-data', {
    state: () => ({
        googleRecaptchaSettings: null as GoogleRecaptchaSettings|null
    })
})
